export const excludeArticleDiscount = [
    "bt9020",
    "bt7801",
    "bt7802",
    "bt7803",
    "bt1004+bt4009",
    "bt1007+bt4009",
    "bt1008+bt4009",
    "bt1010+bt4009",
    "bt1012+bt4009",
    "bt1014+bt4009",
    "bt1022+bt4009",
    "bt1023+bt4009",
    "bt1024+bt4009",
    "bt1026+bt4009",
    "bt1030+bt4009",
    "bt1041+bt4009",
    "YELLOW-2022",
    "BLACK-2022",
    ""
]

